import { useEffect, useState } from "react";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n2 } from "../../lib/format";
import { iso, monthStart } from "../../lib/dates";
import { Notice } from "../../lib/ui";

/* Income statement for a period – port of income_statement.php (API: /api/reports/income-statement) */

export default function IncomeStatement() {
  const api = useApi();
  const [f, setF] = useState({ from: iso(monthStart(new Date())), to: iso(new Date()) });
  const [d, setD] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => { api.get("/api/reports/income-statement", f).then(setD).catch((e) => setError(e.message)); }, [api, f]);
  const Lines = ({ rows }) => rows.map((r) => <tr key={r.number}><td><span className="mono" style={{ color: "var(--muted)", marginRight: ".6rem" }}>{r.number}</span>{r.name}</td><td className="num mono">{n2(r.amount)}</td></tr>);
  return (
    <main className="pg" style={{ maxWidth: "56rem" }}>
      <PageHeader slug="income_statement" actions={<>
        <input type="date" aria-label="From" value={f.from} onChange={(e) => setF({ ...f, from: e.target.value })} />
        <input type="date" aria-label="To" value={f.to} onChange={(e) => setF({ ...f, to: e.target.value })} />
        <button type="button" className="btn" onClick={() => window.print()}><i className="fas fa-print" /> Print</button></>} />
      <Notice notice={error && { tone: "err", text: error }} />
      {d && (
        <section className="panel fs">
          <div className="fs-head"><h2>AE2C Enterprise</h2><p>Income statement, {d.from} to {d.to}</p></div>
          <table className="tbl"><tbody>
            <tr className="fs-sec"><td colSpan={2}>Revenue</td></tr><Lines rows={d.revenue} />
            <tr className="fs-total"><td>Total revenue</td><td className="num mono">{n2(d.total_revenue)}</td></tr>
            <tr className="fs-sec"><td colSpan={2}>Cost of goods sold</td></tr><Lines rows={d.cogs} />
            <tr className="fs-total"><td>Total cost of goods sold</td><td className="num mono">{n2(d.total_cogs)}</td></tr>
            <tr className="fs-total strong"><td>Gross profit</td><td className="num mono">{n2(d.gross_profit)}</td></tr>
            <tr className="fs-sec"><td colSpan={2}>Operating expenses</td></tr><Lines rows={d.expenses} />
            <tr className="fs-total"><td>Total expenses</td><td className="num mono">{n2(d.total_expenses)}</td></tr>
            <tr className="fs-total strong"><td>Net income</td><td className="num mono" style={{ color: d.net_income >= 0 ? "var(--up)" : "var(--danger)" }}>{n2(d.net_income)}</td></tr>
          </tbody></table>
        </section>
      )}
    </main>
  );
}
